const data = [
  {
    id: 0,
    heading: "Brand Recognition",
    description:
      "Boost your brand recognition with each click.Boost your brand recognition with each click",
    image: "images/get_paid.svg",
  },
  {
    id: 1,
    heading: "Detailed Records",
    description:
      " Gain insights into who is clicking your links.Boost your brand recognition with each click",
    image: "images/check_price.svg",
  },
  {
    id: 2,
    heading: "Fully Customizable",
    description:
      " Improve brand awareness and content discoverability.Boost your brand recognition with each click",
    image: "images/schedule_pickup.svg",
  },
];

export default data;
